 import { useState, useEffect } from 'react';
 import {  Reclamo } from '../apiTypes';
 import {  readElementsReclami } from '../functionApi';
 import { useAxiosInterceptor } from '../wrappers';

 export const useElementReclamiDettaglio = (reportId?: string, componentId?: string, elementId?: string) => {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [elements, setElements] = useState<Reclamo[]>([]);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState<string | null>(null);
 
   useEffect(() => {
     if (!reportId || !componentId || !elementId) return;
 
     const loadElements = async () => {
       setLoading(true);
       try {
         const data = await readElementsReclami(reportId, componentId, elementId); 
         setElements(data);
         setError(null);
       } catch (err) {
         setError('Errore nel caricamento degli elementi');
         console.error(err);
       } finally {
         setLoading(false);
       }
     };
 
     loadElements();
   }, [reportId, componentId, elementId]);
 
   return { elements, loading, error };
 };
 
 

export default useElementReclamiDettaglio